import { ExtendedAreaProject } from '../api-utilities';
import { areaProjectQuery } from '../generated';
import { COMPOSED_INCLUDE_STRINGS } from './included-properties';

/**
 * @description Returns an array of all areaProjects extended.
 * @return {*}  {Promise<ExtendedAreaProject[]>}
 */
const getExtendedAreaProjects = async (): Promise<ExtendedAreaProject[]> => {
    const areaProjects = (await areaProjectQuery({
        include: COMPOSED_INCLUDE_STRINGS.areaProject,
    })) as ExtendedAreaProject[];

    areaProjects.forEach((areaProject) => {
        areaProject.objectType = 'areaProject';
    });

    return areaProjects;
};

export { getExtendedAreaProjects };
